import { createActions, handleActions } from 'redux-actions';
import { Map } from 'immutable';
import _ from 'lodash';

const initState = Map({
  translateData: [],
  translateQuota: {}
});

export const { addTranslateData, removeTranslateData, removeTranslateDataByPage, setTranslateQuota } = createActions({
  addTranslateData: action => action,
  removeTranslateData: action => action,
  removeTranslateDataByPage: action => action,
  setTranslateQuota: action => action
});

const combinedData = (oldData, translated, track_id, isOtherPage) => {
  let data = [];
  const { texts = [] } = translated;
  if (texts.length) {
    texts.forEach(item => {
      if (item.target_text) {
        if (!oldData.find(x => x.msg_id === item.msg_id && x.targetLanguage === item.target_lang)) {
          data.push({
            msg_id: item.msg_id,
            track_id: track_id,
            translated: item.target_text,
            targetLanguage: item.target_lang,
            sourceLanguage: item.source_lang,
            isOtherPage: isOtherPage
          });
        }
      }
    });
  }
  return data;
};

const translate = handleActions(
  {
    [addTranslateData]: (state, action) => {
      const { payload } = action;
      const { translated, track_id, isOtherPage } = payload;
      const oldData = state.get('translateData');
      return state.set('translateData', [...oldData, ...combinedData(oldData, translated, track_id, isOtherPage)]);
    },
    [removeTranslateData]: (state, action) => {
      const { payload } = action;
      return state.update('translateData', data => {
        if (data.length) {
          return data.filter(item => {
            const { track_id } = item;
            return track_id !== payload;
          });
        }
        return data;
      });
    },
    [removeTranslateDataByPage]: (state, action) => {
      return state.update('translateData', data => {
        if (data.length) {
          return data.filter(item => {
            const { isOtherPage } = item;
            return !isOtherPage;
          });
        }
        return data;
      });
    },
    [setTranslateQuota]: (state, action) => {
      const { payload } = action;
      return state.set('translateQuota', payload);
    }
  },
  initState
);

export default translate;
